import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    process: {},
    blocks: {},
    blockCounts: {}
  },

  mutations: {
    setProcess (state, process) {
      Vue.set(state, 'process', process)
    },

    setData (state, { root, data }) {
      Vue.set(state.blocks, root, data)
    },

    addWorkflow (state, workflow) {
      Vue.set(state.blocks, workflow, {})
    },

    addBlock (state, { workflow, blockName }) {
      Vue.set(state.blocks[workflow], blockName, {})
    },

    setBlockData (state, { workflow, blockName, blockData }) {
      Vue.set(state.blocks[workflow], blockName, blockData)
    },

    addBlockInstance (state, { workflow, blockName, blockIndex }) {
      Vue.set(state.blocks[workflow][blockName], blockIndex, {})
    },

    addGroup (state, { workflow, blockName, blockIndex, group }) {
      Vue.set(state.blocks[workflow][blockName][blockIndex], group, {})
    },

    addField (state, { workflow, blockName, blockIndex, group, field }) {
      Vue.set(state.blocks[workflow][blockName][blockIndex][group], field, '')
    },

    updateField (state, { workflow, blockName, blockIndex, group, field, value }) {
      Vue.set(state.blocks[workflow][blockName][blockIndex][group], field, value)
    },

    setBlockCount (state, { blockCountId, value }) {
      Vue.set(state.blockCounts, blockCountId, value)
    }
  },

  actions: {
    addWorkflow ({ state, commit }, workflow) {
      if (!state.blocks.hasOwnProperty(workflow)) {
        commit('addWorkflow', workflow)
      }
    },

    addBlock ({ state, commit, dispatch }, { workflow, blockName, blockIndex }) {
      dispatch('addWorkflow', workflow)
      if (!state.blocks.hasOwnProperty(workflow)) {
        commit('addWorkflow', workflow)
      }
      if (!state.blocks[workflow].hasOwnProperty(blockName)) {
        commit('addBlock', { workflow, blockName })
      }
      if (!state.blocks[workflow][blockName].hasOwnProperty(blockIndex)) {
        commit('addBlockInstance', { workflow, blockName, blockIndex })
      }
    },

    addGroup ({ state, commit, dispatch }, { workflow, blockName, blockIndex, group }) {
      dispatch('addBlock', { workflow, blockName, blockIndex })
      if (!state.blocks[workflow][blockName][blockIndex].hasOwnProperty(group)) {
        commit('addGroup', { workflow, blockName, blockIndex, group })
      }
    },

    addField ({ state, commit, dispatch }, { workflow, blockName, blockIndex, group, field }) {
      dispatch('addGroup', { workflow, blockName, blockIndex, group })
      if (!state.blocks[workflow][blockName][blockIndex][group].hasOwnProperty(field)) {
        commit('addField', { workflow, blockName, blockIndex, group, field })
      }
    },

    updateField ({ commit, dispatch }, { workflow, blockName, blockIndex, group, field, value }) {
      dispatch('addField', { workflow, blockName, blockIndex, group, field })
      commit('updateField', { workflow, blockName, blockIndex, group, field, value })
    },

    removeBlock ({ state, commit, dispatch }, { workflow, blockName, blockIndex }) {
      if (!state.blocks.hasOwnProperty(workflow)) { return }
      if (!state.blocks[workflow].hasOwnProperty(blockName)) { return }
      if (!state.blocks[workflow][blockName].hasOwnProperty(blockIndex)) { return }

      let blockData = {}
      for (let oldBlockIndex in state.blocks[workflow][blockName]) {
        if (oldBlockIndex !== blockIndex) {
          blockData[oldBlockIndex] = state.blocks[workflow][blockName][oldBlockIndex]
        }
      }

      commit('setBlockData', { workflow, blockName, blockData })
    }
  }
}
